/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { JSONMap as e } from "../../core/jsonMap.js";
var n = new e({
  preserveShape: "preserve-shape"
});

function o(e) {
  var _e$toJSON = e.toJSON(),
      o = _e$toJSON.polylines,
      t = _e$toJSON.lengthUnit,
      i = _e$toJSON.geodesic,
      s = _e$toJSON.calculationType,
      r = {};

  r.polylines = JSON.stringify(o);
  var l = e.polylines[0].spatialReference;
  return r.sr = l.wkid ? l.wkid : JSON.stringify(l.toJSON()), t && (r.lengthUnit = t), i && (r.geodesic = i), s && (r.calculationType = n.toJSON(s)), r;
}

export { o as lengthsToRESTParameters };